module.exports = __webpack_public_path__ + "account/assets/awards.fafe957f.svg";